import { motion } from "framer-motion";
import FileInput from "../../components/reusable/FileInput";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    hover: { scale: 1.02 },
    tap: { scale: 0.98 }
};

const LoadingIndicator = ({ variant = "light" }) => {
    const baseClasses = "inline-block h-5 w-5 border-2 rounded-full animate-spin";
    const colorClasses = variant === "light"
        ? "border-white border-t-transparent"
        : "border-primary border-t-transparent";

    return <span className={`${baseClasses} ${colorClasses}`} aria-hidden="true" />;
};

const StepTwoForm = ({ formData, handleChange, handleSubmit, handleSkip, isSubmitting, activeAction, formErrors, generalError }) => {
    const baseInputClasses = "w-full h-input md:h-input-md sl:h-input-md ll:h-input-lg px-4 md:px-6 sl:px-6 ll:px-8 bg-accent rounded-lg focus:outline-none text-base md:text-md sl:text-lg ll:text-xl placeholder:text-secondary/70 border";
    const getInputClasses = (hasError) =>
        `${baseInputClasses} ${hasError ? "border-red-500 focus:ring-2 focus:ring-red-500" : "border-transparent focus:ring-2 focus:ring-primary"}`;

    return (
    <motion.form
        className="space-y-4 md:space-y-6 sl:space-y-4 ll:space-y-7 pt-8 ll:pt-0"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
    >
        {generalError && (
            <motion.div
                variants={itemVariants}
                className="p-3 rounded-md bg-red-50 border border-red-200 text-sm text-red-600"
            >
                {generalError}
            </motion.div>
        )}

        <motion.div variants={itemVariants}>
            <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder="Country (optional)"
                className={getInputClasses(!!formErrors.country)}
                aria-invalid={!!formErrors.country}
            />
            {formErrors.country && (
                <p className="mt-1 text-sm text-red-600">{formErrors.country}</p>
            )}
        </motion.div>

        <motion.div variants={itemVariants}>
            <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City (optional)"
                className={getInputClasses(!!formErrors.city)}
                aria-invalid={!!formErrors.city}
            />
            {formErrors.city && (
                <p className="mt-1 text-sm text-red-600">{formErrors.city}</p>
            )}
        </motion.div>

        <motion.div variants={itemVariants}>
            <input
                type="text"
                name="native_lang"
                value={formData.native_lang}
                onChange={handleChange}
                placeholder="Native Language (optional)"
                className={getInputClasses(!!formErrors.native_lang)}
                aria-invalid={!!formErrors.native_lang}
            />
            {formErrors.native_lang && (
                <p className="mt-1 text-sm text-red-600">{formErrors.native_lang}</p>
            )}
        </motion.div>

        <motion.div variants={itemVariants}>
            <input
                type="text"
                name="nationalId"
                value={formData.nationalId}
                onChange={handleChange}
                placeholder="National ID (optional)"
                className={getInputClasses(!!formErrors.nationalId)}
                aria-invalid={!!formErrors.nationalId}
            />
            {formErrors.nationalId && (
                <p className="mt-1 text-sm text-red-600">{formErrors.nationalId}</p>
            )}
        </motion.div>

        <motion.div variants={itemVariants}>
            <input
                type="date"
                name="birth_date"
                value={formData.birth_date}
                onChange={handleChange}
                className={getInputClasses(!!formErrors.birth_date)}
                aria-invalid={!!formErrors.birth_date}
            />
            {formErrors.birth_date && (
                <p className="mt-1 text-sm text-red-600">{formErrors.birth_date}</p>
            )}
        </motion.div>

        <motion.div variants={itemVariants}>
            <FileInput
                id="image"
                onChange={handleChange}
                disabled={isSubmitting}
            />
            {formErrors.image && (
                <p className="mt-1 text-sm text-red-600">{formErrors.image}</p>
            )}
        </motion.div>

        <motion.div
            className="flex flex-col sm:flex-row gap-3 md:gap-2 sl:gap-4 ll:gap-6"
            variants={itemVariants}
        >
            <motion.button
                type="button"
                disabled={isSubmitting}
                onClick={handleSubmit}
                className="flex items-center justify-center gap-2 w-full h-input md:h-input-md sl:h-input-md ll:h-input-lg bg-primary text-white text-md md:text-md sl:text-lg ll:text-xl rounded-lg hover:bg-primary-hover transition-colors font-medium disabled:opacity-70 disabled:cursor-not-allowed"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
            >
                {isSubmitting && activeAction === "submit" ? <LoadingIndicator /> : "Submit"}
            </motion.button>

            <motion.button
                type="button"
                disabled={isSubmitting}
                onClick={handleSkip}
                className="flex items-center justify-center gap-2 w-full h-input md:h-input-md sl:h-input-md ll:h-input-lg bg-white border-2 border-primary text-primary text-md md:text-md sl:text-lg ll:text-xl rounded-lg hover:bg-accent transition-colors font-medium disabled:opacity-70 disabled:cursor-not-allowed"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
            >
                {isSubmitting && activeAction === "skip" ? <LoadingIndicator variant="dark" /> : "Skip"}
            </motion.button>
        </motion.div>
    </motion.form>
    );
};

export default StepTwoForm;